import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import CommonTable1 from "app/components/Tables/CommonTable1";
import appRoutes from "app/config/routes";
import { FormatFullName } from "app/utils/helper";
import moment from "moment";

const StudentTable = ({ resData, allCheck, setAllCheck, setEmptyState }) => {
  const columns = [
    {
      accessorKey: "registrationNumber",
      header: "Reg.No",
      size: 60,
    },
    {
      header: "Identity",
      accessorKey: "admissionNumber",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Box>
            <div title="SR Number">
              <Typography>SR No: {original?.srNumber ?? "--"}</Typography>
            </div>
            <div title="Admission Number">
              <Typography sx={{ color: "#73E11C" }}>
                Adm No: {original?.admissionNumber ?? "--"}
              </Typography>
            </div>
            <div title="Reg. Number">
              <Typography sx={{ color: "#2789FD" }}>
                Reg No: {original?.registrationNumber ?? "--"}
              </Typography>
            </div>
            <div title="PEN Number">
              <Typography>
                PEN No: {original?.penNumber_center ?? "--"}
              </Typography>
            </div>
          </Box>
        );
      },
      size: 60,
    },
    {
      header: "Student Name",
      accessorKey: "firstName",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <>
            <Stack direction="row" alignItems="center" gap={0.6}>
              <Link
                to={`/${appRoutes.student_profile}/${original?._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Typography>
                  {FormatFullName(
                    original?.firstName,
                    original?.middleName,
                    original?.lastName
                  )}
                </Typography>
              </Link>
            </Stack>
          </>
        );
      },
      size: 80,
    },
    {
      accessorKey: "gender",
      header: "Gender",
      size: 50,
    },
    {
      accessorFn: (row) => row.category,
      header: "Category",
      id: "category",
      size: 70,
    },
    {
      accessorFn: (row) => {
        return moment(new Date(row.admissionDate)).format("DD MMM, YYYY");
      },
      header: "Admission Date",
      id: "admissionDate",
      size: 80,
    },
    {
      id: "actions",
      header: "Action",
      Header: () => {
        return (
          <Stack direction="row" alignItems="center" gap={0.8}>
            <input
              type="checkbox"
              id="checkAllCertificates"
              checked={allCheck}
              style={{ cursor: "pointer", width: "20px", height: "20px" }}
              onChange={(e) => setAllCheck((prev) => !prev)}
            />
            <Typography>Actions</Typography>
          </Stack>
        );
      },
      size: 60,
      Cell: ({ cell, row }) => (
        <div
          style={{
            width: "35px",
            height: "35px",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            id={`certificate-checkbox-${row.id}`}
            checked={row?.original?.checked}
            style={{ cursor: "pointer", width: "20px", height: "20px" }}
            onChange={(e) => {
              resData[Number(row.id)]["checked"] = !row?.original?.checked;
              setEmptyState((prev) => !prev);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <CommonTable1
        columns={columns}
        data={resData}
        enableRowSelection={false}
        enableRowNumbers={true}
        enablePagination={true}
        enableColumnFilters={true}
        enableSorting={true}
        enableGlobalFilter={true}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableHiding={false}
        enableColumnActions={false}
        paginationDisplayMode="pages"
      />
    </Box>
  );
};

export default StudentTable;
